<template>
    <settings-wrapper title="User settings" section="Nuvolos settings">
        <v-row>
            <v-col>
                <h3>Date time</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-card>
                    <v-card-title>Always timestamp</v-card-title>
                    <v-card-text>
                        Show date times always as timestamp (example: "2025-01-01 12:00") or use relative expressions for recent events (example: "5 minutes
                        ago")
                    </v-card-text>
                    <v-card-actions>
                        <v-btn :disabled="fetchingUserInfo" text color="primary" @click="dateTimeNoString = !dateTimeNoString">
                            {{ dateTimeNoString ? 'Disable' : 'Enable' }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <h3>Appearance</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" class="d-flex">
                <v-card class="d-flex flex-column w-100">
                    <v-card-text>
                        <div class="d-flex align-center mb-2">
                            <v-icon class="mr-3" color="amber darken-2">mdi-weather-sunny</v-icon>
                            <div class="text-body-1">Dim sidebar</div>
                        </div>
                        <div>Invert the sidebar colors for a dimmed look across navigation sidebars.</div>
                    </v-card-text>
                    <v-card-actions class="mt-auto">
                        <v-btn :disabled="fetchingUserInfo" text color="primary" @click="toggleSidebarBrightness()">
                            {{ dimmedSidebar ? 'Disable' : 'Enable' }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </settings-wrapper>
</template>

<script>
import { mapState } from 'vuex'
import SettingsWrapper from '@/components/SettingsWrapper.vue'

export default {
    name: 'UserSettingsNuvolos',
    mixins: [],
    components: {
        SettingsWrapper
    },
    data() {
        return {
            dateTimeNoString: false,
            syncingFromMetadata: false
        }
    },
    computed: {
        ...mapState(['fetchingUserInfo', 'userMetadata', 'dimmedSidebar'])
    },
    methods: {
        toggleSidebarBrightness() {
            this.$store.commit('toggleSidebarBrightness')
        },
        updateUserMetadataProperty(key, value) {
            if (this.fetchingUserInfo || this.syncingFromMetadata) return
            if (this.userMetadata?.[key] === value) return

            this.$store.commit('setUserMetadata', { [key]: value })
        }
    },
    watch: {
        fetchingUserInfo: {
            handler(fetching) {
                if (!fetching) {
                    this.syncingFromMetadata = true
                    this.dateTimeNoString = this.userMetadata.date_time_no_string
                    this.$nextTick(() => {
                        this.syncingFromMetadata = false
                    })
                }
            },
            immediate: true
        },
        dateTimeNoString(value) {
            this.updateUserMetadataProperty('date_time_no_string', value)
        }
    }
}
</script>
